<script>
import Vue from 'vue'
const FooterLogos = Vue.component('footer-logos', {
    name: 'footer-logos',
    delimiters: ['V{', '}'],
    template: '#template-footer-logos'
})

export default FooterLogos
</script>